module.exports = __webpack_public_path__ + "img/wechartCode.1fd7df1c.jpg";